<template>
  <div v-if="loadingData !== null && loadingData !== undefined">
    <v-dialog scrollable v-model="loading" persistent max-width="400">
      <v-card>
        <v-card-title>
          {{ $t("components.membersmanagementtable.please_wait") }}
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md>
            <v-layout row justify-center>
              <v-flex xs12 sm6 md4 lg3>
                <v-progress-circular indeterminate></v-progress-circular>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      scrollable
      v-model="dialogs.createAccount"
      persistent
      max-width="800"
    >
      <material-card
        :title="
          $t('components.membersmanagementtable.create_account_title_{0}', [getName()])
        "
        icon="person_add_alt"
        :color="$vuetify.theme.themes.light.success"
        v-if="dialogs.createAccount"
      >
        <v-card-text>
          <v-form v-model="valid.createAccount" ref="contactInfoForm2">
            <v-container fluid grid-list-md>
              <v-row>
                <v-col>
                  <no-autocomplete-textfield
                    :label="$t('headers.members_management.Email')"
                    v-model="editedItem.Email"
                    :rules="[$rules.email, rules.confirmEmail2]"
                  ></no-autocomplete-textfield>
                </v-col>
                <v-col>
                  <no-autocomplete-textfield
                    :label="$t('components.addmemberwizard.confirm_email')"
                    v-model="confirmEmail"
                    :rules="[$rules.email, rules.confirmEmail2]"
                    @paste="onConfirmEmailPaste"
                  ></no-autocomplete-textfield>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color
            text
            @click="
              dialogs.createAccount = false;
              editedIndex = -1;
              editedItem = {};
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!valid.createAccount"
            :loading="saving"
            color="primary"
            @click="tryCreateAccount()"
          >
            {{ $t("components.membersmanagementtable.create_account") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <v-dialog
      scrollable
      v-model="dialogs.changeEmail"
      persistent
      max-width="800"
    >
      <material-card
        :title="
          $t('components.membersmanagementtable.change_email_title_{0}', [getName()])
        "
        icon="alternate_email"
        :color="$vuetify.theme.themes.light.primary"
        v-if="dialogs.changeEmail"
      >
        <v-card-text>
          <v-form v-model="valid.changeEmail" ref="contactInfoForm2">
            <v-container fluid grid-list-md>
              <v-row>
                <v-col>
                  <no-autocomplete-textfield
                    :label="$t('headers.members_management.Email')"
                    v-model="editedItem.Email"
                    :rules="[$rules.email, rules.confirmEmail2]"
                  ></no-autocomplete-textfield>
                </v-col>
                <v-col>
                  <no-autocomplete-textfield
                    :label="$t('components.addmemberwizard.confirm_email')"
                    v-model="confirmEmail"
                    :rules="[$rules.email, rules.confirmEmail2]"
                    @paste="onConfirmEmailPaste"
                  ></no-autocomplete-textfield>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color
            text
            @click="
              dialogs.changeEmail = false;
              editedItem = {};
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!valid.changeEmail"
            :loading="saving"
            color="primary"
            @click="tryChangeMemberEmail()"
          >
            {{ $t("components.membersmanagementtable.change_email") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <v-dialog
      scrollable
      v-model="dialogs.sendWelcomeKitNewUser"
      persistent
      max-width="800"
    >
      <material-card
        :title="$t('components.membersmanagementtable.send_welcome_kit_new')"
        icon="alternate_email"
        :color="$vuetify.theme.themes.light.primary"
        v-if="dialogs.sendWelcomeKitNewUser"
      >
        <v-card-text>
          {{ $t("components.membersmanagementtable.send_welcome_kit_email_new_confirm") }}
        </v-card-text>
        <v-card-text>
          <v-form v-model="valid.sendWelcomeKitNewUser" ref="welcomeKitForm">
            <v-container fluid grid-list-md class="py-0">
              <v-row>
                <v-col class="py-0">
                  <no-autocomplete-textfield
                    class="pt-0"
                    :label="$t('headers.members_management.Email')"
                    v-model="welcomeKitEmail"
                    :rules="[$rules.email]"
                  ></no-autocomplete-textfield>
                </v-col>
                <v-col cols="3" class="py-0">
                  <v-select
                    class="pt-0"
                    :items="languages"
                    v-model="language"
                    :label="$t('globals.language')"
                    hide-details
                  ></v-select>
                </v-col>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn
            color
            text
            @click="
              dialogs.sendWelcomeKitNewUser = false;
              welcomeKitEmail = null;
            "
          >
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :disabled="!valid.sendWelcomeKitNewUser"
            :loading="saving"
            color="primary"
            @click="resendWelcomeKitEmail(welcomeKitEmail)"
          >
            {{ $t("components.usersmanagementtable.send_welcome_kit") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <v-dialog
      scrollable
      v-model="dialogs.resendEmail"
      persistent
      max-width="500"
    >
      <material-card
        :title="
          $t('components.membersmanagementtable.send_registration_email_title_{0}', [
            getName(),
          ])
        "
        icon="forward_to_inbox"
        :color="$vuetify.theme.themes.light.primary"
        v-if="dialogs.resendEmail"
      >
        <v-card-text>
          {{
            $t("components.membersmanagementtable.send_registration_email_confirm_{0}", [
              getName(),
            ])
          }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="dialogs.resendEmail = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving"
            color="primary"
            @click="resendRegistrationEmail()"
          >
            {{ $t("components.membersmanagementtable.send_email") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <v-dialog
      scrollable
      v-model="dialogs.resendConfirmationEmail"
      persistent
      max-width="500"
    >
      <material-card
        :title="$t('components.membersmanagementtable.send_confirmation_email')"
        icon="mark_email_read"
        :color="$vuetify.theme.themes.light.primary"
        v-if="dialogs.resendConfirmationEmail"
      >
        <v-card-text>
          {{
            $t("components.membersmanagementtable.send_confirmation_email_confirm_{0}", [
              getName(),
            ])
          }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="dialogs.resendConfirmationEmail = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving"
            color="primary"
            @click="resendConfirmationEmail()"
          >
            {{ $t("components.membersmanagementtable.send_email") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <v-dialog
      scrollable
      v-model="dialogs.resendWelcomeKit"
      persistent
      max-width="500"
    >
      <material-card
        :title="$t('components.membersmanagementtable.resend_welcome_kit_title')"
        icon="mark_email_read"
        :color="$vuetify.theme.themes.light.primary"
        v-if="dialogs.resendWelcomeKit"
      >
        <v-card-text>
          {{
            $t("components.membersmanagementtable.send_welcome_kit_email_confirm_{0}", [
              getName(),
            ])
          }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="dialogs.resendWelcomeKit = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving"
            color="primary"
            @click="resendWelcomeKitEmail()"
          >
            {{ $t("components.usersmanagementtable.send_welcome_kit") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <v-dialog
      v-model="dialogs.deleteAccount"
      persistent
      max-width="400"
      scrollable
    >
      <material-card
        :title="$t('components.usersmanagementtable.confirm_delete_account')"
        icon="person_remove"
        :color="$vuetify.theme.themes.light.error"
        v-if="dialogs.deleteAccount"
      >
        <v-card-text>
          {{ $t("components.usersmanagementtable.confirm_delete_text_{0}", [getName()]) }}
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="dialogs.deleteAccount = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving"
            color="primary"
            @click="tryDeleteMemberPortalAccount()"
          >
            {{ $t("components.membersmanagementtable.delete_account") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <v-dialog
      v-model="dialogs.resetPassword"
      persistent
      max-width="400"
      scrollable
    >
      <material-card
        :title="$t('components.usersmanagementtable.confirm_reset_password')"
        icon="person_remove"
        :color="$vuetify.theme.themes.light.warning"
        v-if="dialogs.resetPassword"
      >
        <v-card-text>
          {{
            $t("components.usersmanagementtable.confirm_reset_password_text_{0}", [
              getName(),
            ])
          }}
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="dialogs.resetPassword = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn
            :loading="saving"
            color="primary"
            @click="tryResetMemberPortalPassword"
          >
            {{ $t("components.membersmanagementtable.reset_password") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>

    <material-card
      :title="
        (selectedPlan && selectedPlan.Name ? selectedPlan.Name + ' ' : '') +
        $t('components.usersmanagementtable.members')
      "
      :color="$vuetify.theme.themes.light.primary"
      icon="folder_shared"
    >
      <template v-slot:title>
        <div>
          <v-tabs v-model="tab">
            <v-tab
              >{{ $t("components.usersmanagementtable.portal_users") }}</v-tab
            >
            <!-- <v-tab
              >{{ $t('components.usersmanagementtable.allowed_users') }}</v-tab
            > -->
            <v-tab
              >{{ $t("components.usersmanagementtable.blocked_users") }}</v-tab
            >
          </v-tabs>
        </div>
      </template>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <pbas-data-table
            ref="table"
            :dataProvider="provider"
            :rowActions="rowActions"
            :floatActions="computedFloatActions"
            @itemsChanged="setData($event)"
            fileNamePrefix="users"
            :identifier="identifier"
            :noSearch="false"
            :showSelect="false"
            @error="error = $event"
          ></pbas-data-table>
        </v-tab-item>
        <!-- <v-tab-item>
          <allowed-users-management-table />
        </v-tab-item> -->
        <v-tab-item>
          <blocked-users-management-table />
        </v-tab-item>
      </v-tabs-items>

      <v-snackbar
        v-model="snackbar"
        :color="color"
        :multi-line="mode === 'multi-line'"
        :timeout="timeout"
        :vertical="mode === 'vertical'"
      >
        {{ message }}
        <v-btn dark text @click="snackbar = false">
          {{ $t("globals.close") }}
        </v-btn>
      </v-snackbar>
    </material-card>

    <error-handler :error="error"></error-handler>
  </div>
  <div v-else>
    <v-row justify="center">
      <v-progress-circular
        :size="70"
        :width="7"
        color="purple"
        indeterminate
      ></v-progress-circular>
    </v-row>
  </div>
</template>

<script>
// import AllowedUsersManagementTable from "../components/AllowedUsersManagementTable";
import BlockedUsersManagementTable from "../components/BlockedUsersManagementTable";
import { mapActions, mapGetters } from "vuex";
import ErrorHandler from "../components/ErrorHandler";
import { ODataProvider as PbasOData } from "pbas-vue-components";
import NoAutocompleteTextfield from "../components/NoAutocompleteTextfield";
import UsersHeaders from "@/headers/PortalUsers";

export default {
  name: "users-management-table",
  components: {
    ErrorHandler,
    NoAutocompleteTextfield,
    // AllowedUsersManagementTable,
    BlockedUsersManagementTable,
  },
  props: ["expandable", "odataUrl", "headersFunc", "identifier", "term"],
  data() {
    return {
      tab: 0,
      languages: ["EN", "FR"],
      language: "en",
      dialogs: {
        createAccount: false,
        changeEmail: false,
        resendEmail: false,
        resendConfirmationEmail: false,
        deleteAccount: false,
        resetPassword: false,
        resendWelcomeKit: false,
        sendWelcomeKitNewUser: false,
      },
      confirmEmail: null,
      welcomeKitEmail: null,
      portalUsers: [],
      currentUser: null,
      error: null,
      provider: undefined,
      floatActions: [],
      rowActions: [
        {
          name: "resendEmail",
          icon: "forward_to_inbox",
          title: "components.memberview.resend_confirmation_email",
          handler: (item) => {
            console.log("resend confirmation email", item);
            this.currentUser = item;
            this.dialogs.resendConfirmationEmail = true;
          },
          visible: (item) => {
            return item;
          },
        },
        {
          name: "resetPassword",
          icon: "lock_reset",
          title: "components.membersmanagementtable.reset_password",
          handler: (item) => {
            console.log("reset passord", item);
            this.currentUser = item;
            this.dialogs.resetPassword = true;
          },
          visible: (item) => {
            return item;
          },
        },
        // {
        //   name: "changeEmail",
        //   icon: "switch_account",
        //   title: "components.membersmanagementtable.change_email",
        //   handler: (item) => {
        //     console.log("change email", item);
        //     this.currentUser = item;
        //     this.dialogs.changeEmail = true;
        //   },
        //   visible: (item) => {
        //     return item;
        //   },
        // },
        {
          name: "deleteAccount",
          icon: "person_remove",
          title: "components.membersmanagementtable.delete_account",
          handler: (item) => {
            console.log("delete member portal account", item);
            this.currentUser = item;
            this.dialogs.deleteAccount = true;
          },
          visible: (item) => {
            return item;
          },
        },
        {
          name: "resendWelcomeKit",
          icon: "send_and_archive",
          title: "components.membersmanagementtable.resend_welcome_kit",
          handler: (item) => {
            console.log("resend welcome kit", item);
            this.currentUser = item;
            this.dialogs.resendWelcomeKit = true;
          },
          visible: (item) => {
            return item;
          },
        },
      ],
      computedFloatActions: [
        {
          name: "sendWelcomeKitNewUser",
          icon: "send_time_extension",
          color: "#007cb5",
          text: "components.usersmanagementtable.send_welcome_kit",
          handler: () => (this.dialogs.sendWelcomeKitNewUser = true),
        },
      ],
      snackbar: false,
      color: "",
      mode: "",
      timeout: 2500,
      message: "",
      headers: [],
      loading: false,
      massNotesValid: false,
      expandedRowActions: [],
      editedItem: {},
      loadingData: false,
      saving: false,
      valid: {
        changeEmail: false,
      },
      rules: {
        confirmEmail2: () => {
          if (
            (this.confirmEmail === null || this.confirmEmail === undefined) &&
            (this.editedItem.Email === null || this.editedItem.Email === undefined)
          ) {
            return true;
          }
          return (
            this.confirmEmail === this.editedItem.Email ||
            this.$t("validation.emails_must_match")
          );
        },
      },
    };
  },
  computed: {
    ...mapGetters("auth", ["role"]),
    ...mapGetters("common", { currentLanguage: "language"}),
    ...mapGetters("common", { selectedPlan: "plan" }),
    url: function () {
      if (this.odataUrl !== null && this.odataUrl !== undefined) return this.odataUrl;
      return "plans/" + this.selectedPlan.Id + "/mportal-users";
    },
  },
  watch: {
    confirmEmail: {
      handler() {
        if (this.$refs.contactInfoForm2) {
          this.$refs.contactInfoForm2.validate();
        }
        this.$forceUpdate();
      },
      immediate: true,
    },
  },
  async created() {
    window.addEventListener("beforeunload", this.unload, { capture: true });
    // window.addEventListener('unload', this.unload, {capture: true});
    // document.addEventListener("visibilitychange",this.unload);
    await this.loadPlanData();
  },
  beforeDestroy() {
    window.removeEventListener("beforeunload", this.unload, { capture: true });
  },
  mounted() {
    this.language = this.currentLanguage ? this.currentLanguage.language == "en" ? "EN" : "FR" : "EN";
  },
  async beforeRouteLeave(to, from, next) {
    try {
      await this.$refs.addMemberWizard.tryReleaseCertificate();
    } catch (error) {
      this.error = error;
    }
    next();
  },
  methods: {
    ...mapActions("plansMembers", [
      "getMembersManagementColumns",
      "lockWizard",
      "getBlobAsyncPost",
      "createMassMemberNotes",
      "createMemberPortalAccount",
      "changeMemberEmailPensionsPlan",
      "resendMemberRegistrationEmail",
      "resendMemberConfirmationEmailPensionsPlan",
      "resendWelcomeKitEmailPensionsPlan",
      "deleteMemberPortalAccountPensionsPlan",
      "resetMemberPortalPasswordPensionsPlan",
    ]),
    ...mapActions("common", ["createOdataType"]),
    async unload() {
      console.log("unload");
      if (this.$refs.addMemberWizard) {
        try {
          await this.$refs.addMemberWizard.tryReleaseCertificate();
          console.log("Hello");
          this.sleep(1000);
          console.log("World!");
        } catch (error) {
          this.error = error;
        }
      }
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    onConfirmEmailPaste(event) {
      // console.log("P A S T E: ", event);
      event.preventDefault();
      return false;
    },
    getDataAsync() {
      return this.$refs.table.getDataAsync();
    },
    // generateDependantProvider(item) {
    //   const url =
    //     "plans/" +
    //     this.selectedPlan.Id +
    //     "/members/" +
    //     this.dependantItem.IdentityId +
    //     "/dependants/" +
    //     item.IdentityId +
    //     "/history";
    //   return new PbasOData(
    //     this.$axiosHttp,
    //     url,
    //     this.dependantsHeaders.filter(
    //       (o) =>
    //         (o.visible === true && o.allowVisibilityChange === true) ||
    //         o.allowVisibilityChange === false
    //     )
    //   );
    // },
    async loadPlanData(filter = null) {
      this.loadingData = true;
      try {
        let headers = UsersHeaders;
        if (headers.length === 0) {
          this.error = {
            customMessage: this.$t("errors.no_headers"),
          };
          return;
        }

        this.headers = headers;
        // const h2 = this.$helpers.createOdataHeaders(
        //   headers.filter((h) => {
        //     // console.log(h);
        //     return h.showOnExpandOnly !== true;
        //   }),
        //   "headers.users_management."
        // );
        //console.log(h2.map(i => i.title))
        //console.log(h2.filter(o=>o.value.indexOf("MemberGroup") > -1));
        console.log("headers", headers);
        if (!filter) {
          this.$nextTick(() => {
            this.provider = new PbasOData(this.$axiosHttp, this.url, UsersHeaders);
            // this.provider.filter = ['PlanMemberships/any(m: m/NeospinMemberId ne null)'];
            // this.provider = new PbasOData(this.$axiosHttp, this.url, UsersHeaders);
            //     this.provider = new InMemoryProvider(
            //   this.portalUsers,
            //   headers
            // );
          });
        } else {
          //   const pr = new InMemoryProvider(
          //     this.portalUsers,
          //   headers
          // );
          const pr = new PbasOData(this.$axiosHttp, this.url, UsersHeaders);
          pr.filter = filter;
          this.provider = pr;
        }
      } catch (error) {
        this.error = error;
      } finally {
        this.loadingData = false;
      }
    },
    async submitSearchForm() {
      const filters = [];
      this.provider.filter = undefined;
      if (this.searchForm.firstName) {
        filters.push(
          `tolower(CurrentMember/FirstName) eq '${this.searchForm.firstName.toLowerCase()}'`
        );
      }
      if (this.searchForm.lastName) {
        filters.push(
          `tolower(CurrentMember/LastName) eq '${this.searchForm.lastName.toLowerCase()}'`
        );
      }
      if (this.searchForm.certificate) {
        filters.push(
          `MemberIdentification/Certificate eq '${this.searchForm.certificate}'`
        );
      }
      if (this.searchForm.sin) {
        filters.push(`MemberIdentification/SIN eq '${this.searchForm.sin}'`);
      }
      if (filters.length > 0) {
        this.provider.filter = filters.join(" and ");
      }
      this.$refs.table.getDataAsync();
      //await this.loadPlanData(filters.join(" and "));
    },
    setData(items) {
      // console.log("setData emit setUsers");
      this.$emit("setUsers", items);
      // for (let item of items) {
      //   if (item.TerminatedAt) {

      //   }
      // }
    },
    async exportMembers() {
      this.loading = true;
      const url = "plans/" + this.selectedPlan.Id + "/member-export";

      const filename = "Members.xlsx";
      let columns = this.headers.filter(
        (c) =>
          this.provider.headers.filter(
            (h) => h.visible === true && h.type.key === c.value
          ).length > 0
      );
      console.log(columns);
      try {
        let blob = (
          await this.getBlobAsyncPost({
            url: url,
            filename: filename,
            payload: columns.map((o) => this.$t("headers.members_management." + o.text)),
          })
        ).data;

        const url2 = window.URL.createObjectURL(new Blob([blob]));
        const link = document.createElement("a");
        link.href = url2;
        link.setAttribute("download", filename); //or any other extension
        link.setAttribute("id", "link1"); //or any other extension
        document.body.appendChild(link);
        link.click();
        var element = document.getElementById("link1");
        element.parentNode.removeChild(element);
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    // async viewDependants(item) {
    //   this.dependantItem = item;
    //   this.dependantsProvider = new PbasOData(
    //     this.$axiosHttp,
    //     this.dependantUrl,
    //     this.dependantsHeaders
    //   );
    //   this.dialogs.viewDependants = true;
    // },

    async add() {
      try {
        await this.lock(
          this.lockWizard,
          {
            plan: this.selectedPlan.Id,
            dialogs: this.dialogs,
            dialog: "add",
          },
          () => {
            this.dialogs.add = false;
          }
        );
        this.dialogs.add = true;
      } catch (error) {
        this.error = error;
      }
    },
    getName() {
      return (this.currentUser && this.currentUser.UserName) || "";
    },
    async createAccountHandler() {
      try {
        this.editedItem = await this.lock(
          this.getMemberInfo,
          {
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: this.id,
            odataQuery: "$select=Email",
            dialogs: this.dialogs,
            dialog: "createAccount",
          },
          () => {
            this.dialogs.createAccount = false;
          }
        );
        this.dialogs.createAccount = true;
      } catch (error) {
        this.error = error;
      }
    },
    async tryCreateAccount() {
      try {
        this.saving = true;
        await this.createMemberPortalAccount({
          planIdentityId: this.selectedPlan.Id,
          payload: {
            MemberIdentityId: this.id,
            Email: this.editedItem.Email,
          },
        });
        this.color = "warning";
        this.message = this.$t("components.addmemberwizard.email_portal_warning");
        this.snackbar = true;
        this.dialogs.createAccount = false;
        this.editedItem = {};
        this.reloadMemberIdentity();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async changeMemberEmailHandler() {
      // let query = "$expand=CurrentContactInformation($select=HomeEmail)";
      // if (this.memberIdentity.CurrentContactInformation.PrimaryEmail === "Work") {
      //   query = "$expand=CurrentContactInformation($select=WorkEmail)";
      // }
      try {
        this.editedItem = await this.lock(
          this.getMemberInfo,
          {
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: this.id,
            // odataQuery: query,
            odataQuery: "$select=Email",
            dialogs: this.dialogs,
            dialog: "changeEmail",
          },
          () => {
            this.dialogs.changeEmail = false;
          }
        );
        this.dialogs.changeEmail = true;
      } catch (error) {
        this.error = error;
      }
    },
    async tryChangeMemberEmail() {
      try {
        this.saving = true;
        let resp = await this.changeMemberEmail({
          planIdentityId: this.selectedPlan.Id,
          payload: {
            MemberIdentityId: this.id,
            Email: this.editedItem.Email,
          },
        });
        if (resp.data === 1) {
          this.color = "warning";
          this.message = this.$t(
            "New confirmation email message will be sent to the member"
          );
        } else if (resp.data === 2) {
          this.color = "warning";
          this.message = this.$t(
            "New registration email message will be sent to the member"
          );
        } else {
          this.color = "success";
          this.message = this.$t("globals.success");
        }

        this.snackbar = true;
        this.dialogs.changeEmail = false;
        this.editedItem = {};
        // this.getDataAsync();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async resendRegistrationEmail() {
      this.saving = true;
      try {
        await this.resendMemberRegistrationEmail({
          planIdentityId: this.selectedPlan.Id,
          payload: {
            MemberIdentityId: this.id,
          },
        });
        this.color = "success";
        this.message = this.$t("globals.success");
        this.snackbar = true;
        this.editedItem = {};
        this.dialogs.resendEmail = false;
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async resendConfirmationEmail() {
      console.log("resendConfirmationEmail");
      this.saving = true;
      try {
        await this.resendMemberConfirmationEmailPensionsPlan({
          planIdentityId: this.selectedPlan.Id,
          payload: {
            UserName: this.currentUser.UserName,
            UserId: this.currentUser.Id,
            ReturnUrl: this.currentUser.PlanMemberships.find(
              (x) => x.NeospinMemberId !== null
            ).Url,
          },
        });
        this.color = "success";
        this.message = this.$t("globals.success");
        this.snackbar = true;
        this.editedItem = {};
        this.currentUser = null;
        this.dialogs.resendConfirmationEmail = false;
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async resendWelcomeKitEmail(newUserEmail) {
      console.log("Send Welcome Kit to new user", this.selectedPlan.Id);
      this.saving = true;
      try {
        await this.resendWelcomeKitEmailPensionsPlan({
          planIdentityId: this.selectedPlan.Id,
          payload: {
            Email: newUserEmail ? newUserEmail : this.currentUser.UserName,
            FirstName: "",
            LastName: "",
            ReturnUrl: this.currentUser
              ? this.currentUser.PlanMemberships.find((x) => x.NeospinMemberId !== null)
                  .Url
              : "",
            PlanId: this.currentUser
              ? this.currentUser.PlanMemberships.find((x) => x.NeospinMemberId !== null)
                  .PlanId
              : this.selectedPlan.Id,
            LanguageCode: this.language ? this.language.toLowerCase() : "en",
          },
        });
        this.color = "success";
        this.message = this.$t("globals.success");
        this.snackbar = true;
        this.editedItem = {};
        this.currentUser = null;
        this.dialogs.resendWelcomeKit = false;
        this.dialogs.sendWelcomeKitNewUser = false;
        this.welcomeKitEmail = null;
      } catch (error) {
        console.log(error);
        this.error = { customMessage: error.response.data };
      }
      this.saving = false;
    },
    async deleteAccountHandler() {
      //console.log("delete----");
      try {
        this.editedItem = await this.lock(
          this.getMemberInfo,
          {
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: this.id,
            odataQuery: "$select=Email",
            dialogs: this.dialogs,
            dialog: "deleteAccount",
          },
          () => {
            this.dialogs.deleteAccount = false;
          }
        );
        this.dialogs.deleteAccount = true;
      } catch (error) {
        this.error = error;
      }
    },
    async tryDeleteMemberPortalAccount() {
      try {
        this.saving = true;
        await this.deleteMemberPortalAccountPensionsPlan({
          planIdentityId: this.selectedPlan.Id,
          payload: {
            UserName: this.currentUser.UserName,
            UserId: this.currentUser.Id,
            ReturnUrl:
              this.currentUser.PlanMemberships &&
              this.currentUser.PlanMemberships.find((x) => x.NeospinMemberId !== null)
                .Url,
          },
        });
        this.dialogs.deleteAccount = false;
        this.color = "success";
        this.message = this.$t("globals.success");
        this.snackbar = true;
        this.editedItem = {};
        this.currentUser = null;
        this.$refs.table.getDataAsync();
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
    async resetPasswordHandler() {
      //console.log("delete----");
      try {
        this.editedItem = await this.lock(
          this.getMemberInfo,
          {
            planIdentityId: this.selectedPlan.Id,
            memberIdentityId: this.id,
            odataQuery: "$select=Email",
            dialogs: this.dialogs,
            dialog: "resetPassword",
          },
          () => {
            this.dialogs.resetPassword = false;
          }
        );
        this.dialogs.resetPassword = true;
      } catch (error) {
        this.error = error;
      }
    },
    async tryResetMemberPortalPassword() {
      try {
        this.saving = true;
        await this.resetMemberPortalPasswordPensionsPlan({
          planIdentityId: this.selectedPlan.Id,
          payload: {
            UserName: this.currentUser.UserName,
            UserId: this.currentUser.Id,
            ReturnUrl: this.currentUser.PlanMemberships.find(
              (x) => x.NeospinMemberId !== null
            ).Url,
          },
        });
        this.dialogs.resetPassword = false;
        this.color = "success";
        this.message = this.$t("globals.success");
        this.snackbar = true;
        this.currentUser = null;
      } catch (error) {
        this.error = error;
      }
      this.saving = false;
    },
  },
};
</script>

<style>
.background-red {
  background-color: red;
}
.background-green {
  background-color: green;
}
.full-width {
  width: 100%;
}
.terminated {
  background-color: red;
}
</style>
